import usePlankTableStore from '@/views/ddp/hooks/usePlankTableStore';
import useTooltipVoorraad from '@/views/ddp/hooks/useTooltipVoorraad';
import { getClaimsTotaal } from '@/views/ddp/utils/voorraadbeheer';

import Details from '../../Details/Details';
import VoorraadDots from '../../VoorraadBeheer/VoorraadDots';

import styles from './TabVoorraad.module.css';

const TabVoorraad = () => {
  const voorraad = usePlankTableStore((state) => state.sidepanel.voorraad);

  const { showTooltip, updateTooltip, hideTooltip } = useTooltipVoorraad();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {voorraad?.knoopgebieden?.map((knoopgebied) => (
        <div
          key={knoopgebied.knoopgebied}
          style={{
            borderBottom: '1px solid var(--tractie-color-border-default)',
          }}
        >
          <Details
            summary={
              <a
                onMouseEnter={showTooltip(knoopgebied.knoopgebied, knoopgebied)}
                onMouseMove={updateTooltip(knoopgebied.knoopgebied, knoopgebied)}
                onMouseLeave={hideTooltip}
                style={{ textDecoration: 'none', width: '100%' }}
                data-testid='plank-header'
              >
                <div className={styles.knoopgebiedSummaryDiv} style={{ paddingRight: 0 }}>
                  {knoopgebied.knoopgebied}{' '}
                  <VoorraadDots
                    aantal={knoopgebied.overOfTekort}
                    claimsCount={getClaimsTotaal(knoopgebied.claims)}
                    beschikbareReizigersdienst={knoopgebied.aanwezig - knoopgebied.inzetten - knoopgebied.nietInzetbaar}
                    nvt={knoopgebied.nvt}
                  />
                </div>
              </a>
            }
          >
            <ul className={styles.knoopListUl}>
              {knoopgebied.knopen.map((knoop) => (
                <li
                  key={knoop.knoop === 'Onbekend' ? (knoop?.dienstregelpunt ?? knoop.knoop) : knoop.knoop}
                  className={styles.knoopListLi}
                >
                  <a
                    onMouseEnter={showTooltip(knoop.knoop, knoop)}
                    onMouseMove={updateTooltip(knoop.knoop, knoop)}
                    onMouseLeave={hideTooltip}
                    style={{ textDecoration: 'none' }}
                  >
                    <div className={styles.knoopListLiDiv}>
                      {knoop.knoop === 'Onbekend' ? (knoop?.dienstregelpunt ?? knoop.knoop) : knoop.knoop}{' '}
                      <VoorraadDots
                        aantal={knoop.overOfTekort}
                        claimsCount={getClaimsTotaal(knoop.claims)}
                        beschikbareReizigersdienst={knoop.aanwezig - knoop.inzetten - knoop.nietInzetbaar}
                        nvt={knoop.nvt}
                      />
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </Details>
        </div>
      ))}
    </div>
  );
};
export default TabVoorraad;
